import { BehaviorSubject } from 'rxjs';
import ApiCore from './common/api-core';
import { handleResponse } from '../helpers';

const url = "EntrepriseApi";
const currentUserSubject = new BehaviorSubject(localStorage.getItem('token'));

const apiTasks = new ApiCore({
  getAll: true,
  getSingle: true,
  post: true,
  put: true,
  patch: true,
  delete: true,
  url: url
});

export const companyService = {
  companylogin,
  getAllCategories,
  getCompaniesByCategoryAndLocationAndCompanyid,
  getCompaniesByCategoryAndLocationAndCompanyidNotConnected,
  getCompanyDisponibilities,
  getCompanyDisponibilitiesNotConnected,
  getCompanyServicesByParameter,
  getCompanyServicesByParameterNotConnected,
  
  saveWorkingHours,
  saveCustomConfigCompany,
  getCompanyEmployees,
  getCompanyEmployeesNotConnected,
  requestCompany,
  addCompany,
  modifyCompany,
  deleteCompany,
  addEmployeetoCompany,
  modifyEmployeetoCompany,
  deleteEmployeetoCompany,
  addCompanyService,
  updateCompanyService,
  deleteCompanyService,
};


function companylogin(usernameText, emailText, passwordText, returnurlText) {
  return apiTasks.post('CompanyLogin', {
    username: usernameText,
    email: emailText,
    password: passwordText,
    returnurl: returnurlText,
    grant_type: 'password',
  })
    .then(function (response) {
      if (!response.isAxiosError) {
            localStorage.setItem('token', response.token);
            currentUserSubject.next(response.token);
        //currentUserSubject.next(response.token);
            // return both user and token
          return {
            user: response.user,
            token: response.token
          };
      } else {
          
        throw new Error(response.message); // Throw an error to be caught in the catch block
      }
    })
    .catch(function (error) {
      
      throw new Error('Login failed: ' + error.message); // Throw a custom error message
    });
}

function getAllCategories() {
  try {
    return apiTasks.getAll('GetAllEntrepriseCategory')
      .then(function (response) {
        if (!response.isAxiosError) {
          return response;
        } else {
          throw new Error('API request error');
        }
      });
  } catch (error) {
    console.error('API request failed:', error);
    throw error;
  }
}

function getCompaniesByCategoryAndLocationAndCompanyid(category, location,companyid) {

  const params = {
    category: category,
    location: location,
    companyid:companyid
  };
debugger;
  return apiTasks.post('GetCompaniesByParameters',params)// { 'category': category, 'location': location })
    .then(function (response) {
      if (!response.isAxiosError) {
        return response;
      }
    });
}

function getCompaniesByCategoryAndLocationAndCompanyidNotConnected(category, location,companyid) {

  const params = {
    category: category,
    location: location,
    companyid:companyid
  };
  return apiTasks.post('GetCompaniesByParametersNotConnected',params)// { 'category': category, 'location': location })
    .then(function (response) {
      if (!response.isAxiosError) {
        return response;
      }
    });
}

function saveWorkingHours(companyUsername,workinghours) {

  return apiTasks.post('SaveWorkingHours',{companyUsername, workinghours })
    .then(function (response) {
      if (!response.isAxiosError) {
        return response;
      }
    });
}

function saveCustomConfigCompany(companyUsername,updatedCustomConfig) {

  return apiTasks.post('SaveCustomConfigCompany',{username:companyUsername, parameters:updatedCustomConfig })
    .then(function (response) {
      if (!response.isAxiosError) {
        return response;
      }
    });
}



function requestCompany(companyData) {
  return apiTasks.post('RequestCompany', companyData)
    .then(function (response) {
      if (!response.isAxiosError) {
        return response;
      }
    });
}

function addCompany(companyData) {
  return apiTasks.post('CreateCompany', companyData)
    .then(function (response) {
      if (!response.isAxiosError) {
        return response;
      }
    });
}

function getCompanyDisponibilities(company,selectedEmployee,ReferenceDate,numberOfDays,appointmentDuration, onlyAvailableSlots) {
  return apiTasks.post('GetCompanyDisponibilities', {company,employee:selectedEmployee,ReferenceDate,numberOfDays,appointmentDuration, onlyAvailableSlots})
    .then(function (response) {
      if (!response.isAxiosError) {
        return response;
      }
    });
}

function getCompanyDisponibilitiesNotConnected(company,selectedEmployee,ReferenceDate,numberOfDays,appointmentDuration) {
  return apiTasks.post('GetCompanyDisponibilitiesNotConnected', {company,employee:selectedEmployee,ReferenceDate,numberOfDays,appointmentDuration})
    .then(function (response) {
      if (!response.isAxiosError) {
        return response;
      }
    });
}

function getCompanyEmployees(companyUsername) {
  
  return apiTasks.post('GetCompanyEmployees', {Name:companyUsername})
    .then(function (response) {
      if (!response.isAxiosError) {
        return response;
      }
    });
}

function getCompanyEmployeesNotConnected(companyUsername) {
  return apiTasks.post('GetCompanyEmployeesNotConnected', {Name:companyUsername})
    .then(function (response) {
      if (!response.isAxiosError) {
        return response;
      }
    });
}

function getCompanyServicesByParameter(companyid, employee,companycategory) {
  return apiTasks.post('GetCompanyServicesByParameter', {companyId:companyid,employeeUsername:employee,businesscategory:companycategory})
    .then(function (response) {
      if (!response.isAxiosError) {
        return response;
      }
    });
}

function getCompanyServicesByParameterNotConnected(companyid,employee,companycategory) {
  return apiTasks.post('GetCompanyServicesByParameterNotConnected', {companyId:companyid,employeeUsername:employee,businesscategory:companycategory})
    .then(function (response) {
      if (!response.isAxiosError) {
        return response;
      }
    });
}

function modifyCompany(companyId, companyData) {
  return apiTasks.post(`UpdateCompany/${companyId}`, companyData)
    .then(function (response) {
      if (!response.isAxiosError) {
        return response;
      }
    });
}

function deleteCompany(companyId) {
  return apiTasks.delete(`deleteCompany/${companyId}`)
    .then(function (response) {
      if (!response.isAxiosError) {
        return response;
      }
    });
}

function addEmployeetoCompany(companyUsername,employeeUsename,startDate,endDate,meetingTime,breakTimes,services) {
  
  return apiTasks.post('AddEmployeeToCompany',  {companyUsername,Username:employeeUsename,startDate,endDate,meetingTime,breakTimes,EmployeeCompanyServices:services} )
    .then(function (response) {
      if (!response.isAxiosError) {
        return response;
      }
    });
}

function modifyEmployeetoCompany(companyUsername,employeeUsename,planningId,startDate,endDate,meetingTime,breakTimes,services) {
  
  return apiTasks.post('EditEmployeeToCompany',  {companyUsername,Username:employeeUsename,PlanningId:planningId,startDate,endDate,meetingTime,breakTimes,EmployeeCompanyServices:services} )
    .then(function (response) {
      if (!response.isAxiosError) {
        return response;
      }
    });
}

function deleteEmployeetoCompany(companyUsername,planningId) {
  return apiTasks.post('DeleteEmployeeToCompany',  {PlanningId:planningId} )
    .then(function (response) {
      if (!response.isAxiosError) {
        return response;
      }
    });
}

// Add a service to a company
function addCompanyService(companyUsername, serviceData) {
  return apiTasks
    .post("AddCompanyService", {
      CompanyId: companyUsername,
      ServiceTypeId: serviceData.serviceTypeId,
      Price: serviceData.price,
      Currency: serviceData.currency,
      Duration: serviceData.duration,
    })
    .then((response) => {
      if (!response.isAxiosError) {
        return response;
      }
    });
}

// Update a company service
function updateCompanyService(companyUsername,oldService, newService) {

  return apiTasks
    .post("UpdateCompanyService", {
      oldCompanyServiceTypeId: oldService.id,
      oldCompanyServiceType: {
        Id: oldService.id,
        CompanyId: companyUsername,
        ServiceTypeId: oldService.serviceTypeId,
        Price: oldService.price,
        Currency: oldService.currency,
        Duration: oldService.duration,
      },
      newCompanyServiceType: {
        Id: newService.id, // backend might regenerate but keep consistency
        CompanyId: companyUsername,
        ServiceTypeId: newService.serviceTypeId,
        Price: newService.price,
        Currency: newService.currency,
        Duration: newService.duration,
      },
    })
    .then((response) => {
      if (!response.isAxiosError) {
        return response;
      }
    });
}
// Delete a company service
function deleteCompanyService(serviceId) {
  return apiTasks
    .post("DeleteCompanyService", { id: serviceId })
    .then((response) => {
      if (!response.isAxiosError) {
        return response;
      }
    });
}
